// What kind of thing is this cleanup issue? — answered from the slug
// alone, with no database involved.
//
// CONSUMER: both (the detectors run server-side; the decide rail in the
// Cleanup workspace asks the same question in the browser to choose its
// buttons and its plain-English consequence copy)
//
// WHY THIS FILE EXISTS SEPARATELY (2026-09-10 outage). This one-line
// predicate lived in shared/db/cleanup-detectors/shared.ts, next to that
// file's detector-running queries. The Cleanup decide rail imported just
// this function — and dragged shared/db/client.ts and the whole query
// layer into the browser bundle with it. Harmless until a server-only
// Node API entered that chain, at which point it crashed every page of
// the OS before React could mount.
//
// Keeping it here means the browser can have the answer without the
// database coming along. shared/db/cleanup-detectors/shared.ts
// re-exports it, so detector code did not have to change.

/**
 * Is this issue family one where the fix is assigning the right ADVISOR
 * (rather than merging records or editing a field)?
 *
 * Single source of truth for the picker gate, the plain-English
 * consequence copy, and the backend write guard — import this rather
 * than re-deriving the check, so all three can never disagree.
 */
export function isAdvisorAssignmentSlug(slug: string): boolean {
  // realty-cross-company-advisor joined 2026-10-02: until then its "match"
  // fell through to the generic tail and closed the item without
  // reassigning anyone, leaving the other company's advisor on the record.
  return (
    slug.endsWith("unmatched-advisor") ||
    slug === "realty-non-advisor-owner" ||
    slug === "realty-cross-company-advisor"
  );
}
